import merge from "lodash/merge";
import { BookingCategoryFilterV2 } from "PFApp/booking/parts/overview/booking_filters/booking_category_filter_v2";
import { useBookingCategoryFilterOptionsQuery } from "PFApp/booking/parts/overview/booking_filters/hooks/use_booking_category_filter_options_query";
import { AVAILABILITY_SCOPE_LIMIT } from "PFApp/components/filters/filter_items/availability_filter/helpers";
import { useApiFilters, useFiltersV2Actions, useSyncFiltersV2Meta } from "PFApp/components/filters_v2";
import { Meta } from "PFTypes";
import { KnownFiltersV2 } from "PFTypes/filters_v2";
import { useCallback, useEffect } from "react";

type UseWorkforceDataFilters = {
  enabled: boolean;
};

export const useWorkforceDataFilters = ({ enabled }: UseWorkforceDataFilters) => {
  const { areApiFiltersReady, apiFilters } = useApiFilters();

  const bookingCategoryOptionsQuery = useBookingCategoryFilterOptionsQuery();
  const { updateFilter } = useFiltersV2Actions();

  const syncFiltersV2 = useSyncFiltersV2Meta();

  const syncFiltersMeta = useCallback(
    (meta?: Meta) => {
      if (!enabled || !meta?.filtersV2) {
        return;
      }

      meta.total = meta?.counters?.filteredProfilesCount;

      const bookingCategoryFilter = meta.filtersV2?.mainFilters?.[KnownFiltersV2.BookingCategoryId];

      bookingCategoryFilter &&
        merge(meta, {
          filtersV2: {
            mainFilters: {
              [KnownFiltersV2.BookingCategoryId]: {
                optionsQuery: bookingCategoryOptionsQuery,
                InputComponent: BookingCategoryFilterV2,
                limit: AVAILABILITY_SCOPE_LIMIT
              }
            }
          }
        });

      syncFiltersV2(meta);
    },
    [bookingCategoryOptionsQuery, enabled, syncFiltersV2]
  );

  // update filter query when booking categories changed asynchronously due to refetch
  useEffect(() => {
    updateFilter({ name: KnownFiltersV2.BookingCategoryId, optionsQuery: bookingCategoryOptionsQuery });
  }, [bookingCategoryOptionsQuery, updateFilter]);

  return { apiFilters, areApiFiltersReady, syncFiltersMeta };
};
